import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withTheme } from 'styled-components';
import bindMethods from 'auto-bind';

import FormHeadline from '../../components/form/FormHeadline';
import OrgForm from '../../forms/OrgForm';
import SSOButton from '../../components/SSOButton';
import { ButtonContainer, HeadlineContainer } from '../../components/form/FormStyles';

class NewOrg extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    // this holds an instance of Formik's submitForm function
    this.submitForm = null;
  }

  bindSubmitForm(submitForm) {
    this.submitForm = submitForm;
  }

  handleCancelButtonClick() {
    const { history } = this.props;
    return history.goBack();
  }

  handleSubmitForm(event) {
    if (this.submitForm) {
      this.submitForm(event);
    }
  }

  render() {
    const { t, theme } = this.props;

    return (
      <div>
        <HeadlineContainer>
          <FormHeadline
            id="Orgs.New.Headline.GeneralInformation"
            headline={t('Pages.Orgs.Headlines.GeneralInformation')}
          />

          <ButtonContainer>
            <SSOButton
              id="Cancel"
              text={t('Shared.General.Cancel')}
              onClick={this.handleCancelButtonClick}
            />
            <SSOButton
              id="Submit"
              text={t('Pages.Orgs.Actions.CreateNewOrg')}
              onClick={this.handleSubmitForm}
              backgroundColor={theme.PRIMARY}
            />
          </ButtonContainer>
        </HeadlineContainer>
        <OrgForm bindSubmitForm={this.bindSubmitForm} />
      </div>
    );
  }
}

NewOrg.propTypes = {
  history: PropTypes.object.isRequired, // supplied from React Router
  t: PropTypes.func.isRequired, // supplied from withTranslation
  theme: PropTypes.object.isRequired, // supplied from withTheme
};

const TranslatedComponent = withTranslation()(NewOrg);
export default withTheme(TranslatedComponent);
